<template>
  <div class="station-map">
    <!-- <l-map :style="mapHeight" :zoom="map.zoom" :center="map.center" ref="smap" @popupclose="resetSelectedStation" @click="setMarker">
      <l-tile-layer :url="map.url" :attribution="map.attribution"></l-tile-layer>
      <l-marker v-if="!set" v-for="station in extendedStations" :icon="markerIcon" :key="station.id" :lat-lng="[station.lat, station.lng]" @click="selectStation(station)"></l-marker>
      <l-marker v-else v-for="station in extendedStations" :key="station.id" :lat-lng="[station.lat, station.lng]"></l-marker>
      <l-marker v-if="this.markerSet && this.set" :lat-lng="latLng(marker)"></l-marker>
    </l-map> -->
    <div class="map-container">
    <GmapMap
      ref="mapRef"
      :zoom="map.zoom"
      :center="map.center"
      map-type-id="roadmap"
      :options="{ styles: mapStyle, disableDefaultUI: true, gestureHandling: 'greedy' }"
      :icon="mIcon"
      class="map-size"
      :style="mapHeight"
      @click="setMarker">
        <GmapMarker
          :icon="mDynIcon(station)"
          :title="station.name"
          :key="station.id"
          v-for="station in extendedStations"
          :position="{lat: station.lat, lng: station.lng}"
          :clickable="true"
          :draggable="false"
          v-if="!markerSet"
          @click="selectStation(station)"/>

        <GmapMarker
          v-if="showUserPosition"
          title="user-mark"
          :icon="uIcon"
          :position="{ lat: $root.userLocation.lat, lng: $root.userLocation.lng }" />

        <GmapMarker
          v-if="markerSet && set"
          :icon="mIcon"
          :position="marker" />
          
    </GmapMap>
    </div>

    <transition name="slide-in-left">  
      <div class="station-popup" v-if="selectedStation.id">
        <station-popup :station="selectedStation" @close="unSelectStation"/>
      </div>
    </transition>
  </div>
</template>

<script>
import StationPopup from './StationPopup'
import Distance from './../util/distance.js'
import MarkerIcon from '@/assets/pin.svg'
import MarkerIconUserOnly from '@/assets/pin-user-only.svg'
import MarkerIconActive from '@/assets/pin-active.svg'
import MarkerIconMaintainance from '@/assets/pin-maintainance.svg'
import MarkerIconClosed from '@/assets/pin-closed.svg'
import UserMarkerIcon from '@/assets/user-pin-blue.svg'
import GeoCodes from './CountryGeoCodes.json'

import MapStyle from './MapStyle'

export default {
  name: 'StationMap',
  components: { StationPopup },
  props: {
    stations: {
      type: Array,
      required: true
    },
    noInteraction: Boolean,
    height: String,
    selected: Object,
    options: Object,
    set: Boolean,
    showUserPosition: Boolean
  },
  watch: {
    'selected' (selected) {
      this.selectedStation = selected
      if(selected.locationCoordinates) {
        let coor = selected.locationCoordinates.split(',')
        
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo({lat: parseFloat(coor[0]), lng: parseFloat(coor[1])})
        })

      }
    }
  },
  data () {
    return { 
      mapStyle: MapStyle,
      selectedStation: {
        id: null,
        organization: {
          country: {}
        }
      },
      markerSet: false,
      marker: {
        lat: 0,
        lng: 0
      },
      map: {
        zoom: 6,
        center: { lat: 0, lng: 0 }
      }
    }
  },
  computed: {
    uIcon () {
      return UserMarkerIcon
    },
    mIcon () {
      return MarkerIcon
    },
    extendedStations () {
      return this.stations.filter(item => {
        let coor = item.locationCoordinates.split(',')
        item.lat = parseFloat(coor[0])
        item.lng = parseFloat(coor[1])

        return item
      })
    },
    mapHeight () {
      if (this.height) {
        return { height: this.height }
      }

      return {}
    }
  },
  methods: {
    mDynIcon (station) {
      if(!station.public && !station.member) {
        return MarkerIconUserOnly
      } else if(station.statusType == 0) {
        return MarkerIconActive
      } else if(station.statusType == 1) {
        return MarkerIconMaintainance
      } else {
        return MarkerIconClosed
      }
    },
    async getUserCountryCoordinates () {
      const response = await this.$http.get(this.$api.users.get(this.$auth.user.id))
      let countryInfo = GeoCodes.ref_country_codes.find( item => item.country.toLowerCase() === response.data.country.name.toLowerCase())
      
      if (countryInfo) {
        this.map.center.lat = countryInfo.latitude
        this.map.center.lng = countryInfo.longitude

        localStorage.setItem('mapCenter', countryInfo.latitude + ',' + countryInfo.longitude)
      }
    },
    selectStation (station) {
      if (this.noInteraction || this.set) {
        return
      }
      this.selectedStation = station
    },
    unSelectStation () {
      this.selectedStation = {
        id: null,
        organization: {
          country: {}
        }
      }
      this.$emit('unSelect', this.selectedStation)
    },
    getCoordinatesFromStorage () {
      const coords = localStorage.mapCenter.split(',')
      return {
        lat: parseFloat(coords[0]),
        lng: parseFloat(coords[1])
      }
    },
    setMarker (data) {
      if (this.set) {
        this.markerSet = true
        this.marker.lat = data.latLng.lat()
        this.marker.lng = data.latLng.lng()
        this.$emit('setMarker', this.marker)
      }
    }
  },
  created () {
    if (this.$route.query.id) {
      this.map.zoom = 12
      return
    }
      

    if (!this.options || !this.options.center) {
      if (!localStorage.mapCenter) {
        this.getUserCountryCoordinates()
      } else {
        this.map.center.lat = this.getCoordinatesFromStorage().lat
        this.map.center.lng = this.getCoordinatesFromStorage().lng
      }
    }
    if (this.options) {
      this.map.zoom = this.options.zoom || 6
      this.map.center = this.options.center || this.map.center
    }
  }
}
</script>

<style lang="scss" scoped>
  .station-map {
    height: 100%;
  }
  .map-container {
    width: 100%;
    height: 100%;
  }

  .map-size {
    height: 100%;
    width: 100%;
  }

  .station-marker {
    &:hover {
      transform: scale(1.1);
    }
  }

  .station-popup {
    position: absolute;
    width: 350px;
    
    height: calc(100vh - 60px);

    @include breakpoint (xs) {
      height: calc(100vh - 50px);
    }

    background-color: rgba(white, 1);
    z-index: 2000;
    top: 0px;
    left: 0px;
    -webkit-box-shadow: 0px 0px 30px 0px rgba($text-light,.1);
    -moz-box-shadow: 0px 0px 30px 0px rgba($text-light,.1);
    box-shadow: 0px 0px 30px 0px rgba($text-light,.1);

    @include breakpoint (xs) {
      width: 100%;
    }
  }

  .station-map {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/map/StationMap.vue